import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import e from "gatsby-background-image";
import r from "react";

function l() {
  return (l = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var l = arguments[r];

      for (var t in l) {
        Object.prototype.hasOwnProperty.call(l, t) && (e[t] = l[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var t = function t(e) {
  return "[object String]" === Object.prototype.toString.call(e);
},
    n = function n(e) {
  return "fixed" === e.layout ? "fixed" : "fluid";
},
    i = function i(e) {
  var r;

  for (r = 0; r < e.length; r++) {
    if (!t(e[r])) return e[r];
  }

  return null;
},
    u = function u(e) {
  return e.width / e.height;
},
    a = function a(e) {
  var r, l, t, n;
  return e.placeholder ? null != (r = e.placeholder) && null != (l = r.fallback) && l.includes("base64") ? {
    base64: null == (t = e.placeholder) ? void 0 : t.fallback
  } : {
    tracedSVG: null == (n = e.placeholder) ? void 0 : n.fallback
  } : {};
},
    c = function c(e) {
  if (e.srcSet) {
    var r;

    var _l = _toConsumableArray(e.srcSet.matchAll(/(?:([^"'\s,]+)\s*(?:\s+\d+[wx])(?:,\s*)?)/gm)),
        _t = e.sizes.replace("px", ""),
        _n = _l.filter(function (e) {
      return (null == e ? void 0 : e[0].includes("100w")) || (null == e ? void 0 : e[0].includes("1x")) || (null == e ? void 0 : e[0].includes("".concat(_t, "w")));
    });

    return (null == _n || null == (r = _n[0]) ? void 0 : r[1]) || "";
  }

  return "";
},
    s = function s(e) {
  var r, l, t;
  return null != (r = e.images) && r.sources && Array.isArray(null == (l = e.images) ? void 0 : l.sources) ? null == (t = e.images) ? void 0 : t.sources.reduce(function (e, r) {
    var l;
    var t = (null == r || null == (l = r.type) ? void 0 : l.split("/")[1]) || "",
        n = (null == t ? void 0 : t.charAt(0).toUpperCase()) + t.slice(1),
        i = "srcSet".concat(n),
        u = "src".concat(n);
    return n && (!(i in e) && null != r && r.srcSet && (e[i] = r.srcSet), !(u in e) && null != r && r.srcSet && (e[u] = c(r))), e;
  }, {}) : {};
},
    o = function o(e) {
  if (e && e.layout) {
    var _r = {},
        _t2 = n(e),
        _i = u(e),
        _c = a(e),
        _o = s(e);

    return _r[_t2] = l({}, e.images.fallback, _o, _c, "fluid" === _t2 ? {
      aspectRatio: _i
    } : {}, "fixed" === _t2 ? {
      width: e.width,
      height: e.height
    } : {}), _r;
  }

  return null;
};

function d(e) {
  if (e) {
    if (Array.isArray(e)) {
      var _ref = function (e) {
        var r = i(e);

        if (r) {
          var _i2 = n(r),
              _u2 = e.map(function (e) {
            if (t(e)) return e;
            var r = o(e);
            return l({}, r && r[_i2], null != e && e.media ? {
              media: e.media
            } : {});
          });

          return [_i2, _u2];
        }

        return [];
      }(e),
          _ref2 = _slicedToArray(_ref, 2),
          _r2 = _ref2[0],
          _u = _ref2[1];

      return _r2 ? _defineProperty({}, _r2, _u) : null;
    }

    return o(e);
  }

  return null;
}

var f = function f(l) {
  var t = l.image,
      n = l.children,
      i = function (e, r) {
    if (null == e) return {};
    var l,
        t,
        n = {},
        i = Object.keys(e);

    for (t = 0; t < i.length; t++) {
      r.indexOf(l = i[t]) >= 0 || (n[l] = e[l]);
    }

    return n;
  }(l, ["image", "children"]),
      u = t && d(t);

  return u ? r.createElement(e, Object.assign({}, u, i), n) : r.createElement("div", null, n);
};

export { f as BgImage, o as convertSingleBgImage, d as convertToBgImage, s as getAllExtraSrcSets, u as getAspectRatio, n as getBgImageType, a as getPlaceholder, i as getSingleImage, c as getSrc, t as isString };